var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18BBA8",
    stroke: "#18BBA8",
    d: "m17.909 10.053.006-.006c.472-.49.48-1.271-.006-1.76a1.249 1.249 0 0 0-1.764 0l-4.763 4.784-1.936-1.944a1.249 1.249 0 0 0-1.764 0 1.257 1.257 0 0 0 0 1.766l2.817 2.83a1.244 1.244 0 0 0 1.764 0l5.646-5.67ZM3.339 12c0-5.236 4.249-9.5 9.456-9.5 5.208 0 9.457 4.264 9.457 9.5s-4.249 9.5-9.457 9.5c-5.207 0-9.456-4.264-9.456-9.5Z"
  })));
};
export default SvgTickCircle;